import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

/**
 * Informativa sul trattamento dei dati personali.
 *
 * Per i lavoratori non si richiede il consenso — che sarebbe invalido per lo squilibrio
 * tra le parti — ma si documenta l'avvenuta informazione ai sensi dell'art. 13 GDPR.
 * Il pulsante dice infatti "Ho preso visione", non "Accetto".
 *
 * Aggiornando il testo va incrementata VERSIONE: chi ha preso visione della versione
 * precedente rivedrà la schermata, e resta traccia di cosa ciascuno ha letto e quando.
 */
export const VERSIONE = '1.0';

const AZIENDA = 'SOS FIRE S.R.L.S.';
const AZIENDA_DATI = 'Via Appia Nuova 771 – 00178 Roma (RM) – P.IVA 17876171004';
const AZIENDA_EMAIL = 'amministrazione@sosfire.it';
const FORNITORE = 'Centini Monia (P.IVA 18647121005), fornitore della piattaforma Quindi';

const Titolo = ({ children }) => (
  <h4 style={{ margin:'18px 0 6px', fontSize:14, color:'#b30000' }}>{children}</h4>
);
const P = ({ children }) => (
  <p style={{ margin:'0 0 8px', fontSize:13, lineHeight:1.55, color:'#374151' }}>{children}</p>
);

export function TestoInformativa() {
  return (
    <div>
      <P>
        Ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) e dell'art. 4 della
        Legge 300/1970, ti informiamo su come vengono trattati i tuoi dati personali
        nell'ambito dell'utilizzo del gestionale <strong>Quindi</strong>.
      </P>

      <Titolo>Chi tratta i tuoi dati</Titolo>
      <P>
        Titolare del trattamento è <strong>{AZIENDA}</strong>, {AZIENDA_DATI}.
        Per ogni richiesta puoi scrivere a <strong>{AZIENDA_EMAIL}</strong>.
        La piattaforma gestionale è fornita e mantenuta da <strong>{FORNITORE}</strong>,
        che tratta i dati esclusivamente per conto del Titolare in qualità di responsabile
        del trattamento, sulla base di un accordo stipulato ai sensi dell'art. 28 GDPR.
      </P>

      <Titolo>Quali dati vengono trattati</Titolo>
      <P>
        <strong>Dati identificativi e di contatto</strong>: nome, nome utente, indirizzo email,
        ruolo assegnato.<br />
        <strong>Dati di utilizzo</strong>: data e ora degli accessi, tentativi di accesso non
        riusciti, operazioni compiute sui dati aziendali (creazione, modifica, eliminazione),
        indirizzo IP e tipo di dispositivo utilizzato.<br />
        <strong>Dati di attività lavorativa</strong>: interventi assegnati ed eseguiti, orari di
        inizio e fine dichiarati, firma apposta sui verbali, note tecniche redatte.<br />
        <strong>Dati di localizzazione dei veicoli aziendali</strong>, ove presenti dispositivi di
        rilevamento installati sui mezzi.
      </P>

      <Titolo>Perché vengono trattati e su quale base</Titolo>
      <P>
        <strong>Esecuzione del rapporto di lavoro</strong> (art. 6.1.b GDPR): assegnazione e
        gestione degli interventi, redazione dei verbali, documentazione delle attività svolte.<br />
        <strong>Obblighi di legge</strong> (art. 6.1.c GDPR): conservazione della documentazione
        tecnica prevista dalla normativa antincendio e adempimenti fiscali e contabili.<br />
        <strong>Legittimo interesse</strong> (art. 6.1.f GDPR): sicurezza del sistema informativo,
        prevenzione di accessi non autorizzati, tutela del patrimonio aziendale e organizzazione
        dei mezzi.
      </P>
      <P>
        I dati relativi agli accessi e alle operazioni sono raccolti per esigenze di
        <strong> sicurezza del sistema</strong> e non per il controllo a distanza dell'attività
        lavorativa. Non sono utilizzati per finalità disciplinari né per la valutazione del
        rendimento, in conformità all'art. 4 della Legge 300/1970.
      </P>

      <Titolo>Chi può vedere questi dati</Titolo>
      <P>
        Il registro delle attività è consultabile esclusivamente dagli amministratori del sistema.
        I dati possono essere comunicati a soggetti che forniscono servizi strumentali —
        fornitore della piattaforma, servizio di fatturazione elettronica, gestore del servizio
        di posta, fornitore dell'infrastruttura — nominati responsabili del trattamento, nonché
        ad autorità pubbliche quando previsto dalla legge. Non è previsto alcun trasferimento
        al di fuori dello Spazio economico europeo.
      </P>

      <Titolo>Per quanto tempo</Titolo>
      <P>
        Registro degli accessi e delle operazioni: <strong>90 giorni</strong>, poi cancellazione
        automatica.<br />
        Dati relativi a interventi, verbali e documentazione tecnica: per il tempo previsto dalla
        normativa di settore e comunque per la durata degli obblighi di conservazione.<br />
        Dati dell'account: per la durata del rapporto di lavoro e successivamente per il tempo
        necessario ad adempiere agli obblighi di legge.
      </P>

      <Titolo>I tuoi diritti</Titolo>
      <P>
        Puoi in ogni momento chiedere l'accesso ai tuoi dati, la loro rettifica o cancellazione,
        la limitazione del trattamento, e opporti al trattamento fondato sul legittimo interesse
        (artt. 15-22 GDPR). Le richieste vanno indirizzate a {AZIENDA_EMAIL}; riceverai riscontro
        entro un mese. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei
        dati personali (<span style={{ color:'#6b7280' }}>www.garanteprivacy.it</span>).
      </P>

      <Titolo>Natura del conferimento</Titolo>
      <P>
        Il trattamento è necessario per l'utilizzo del gestionale aziendale e per lo svolgimento
        della prestazione lavorativa: non è pertanto richiesto il tuo consenso, ma è nostro dovere
        informarti. Non sono previsti processi decisionali automatizzati né attività di
        profilazione.
      </P>

      <p style={{ margin:'18px 0 0', fontSize:11, color:'#9ca3af' }}>
        Versione {VERSIONE} · Documento aggiornato al luglio 2026
      </p>
    </div>
  );
}

export default function InformativaPrivacy() {
  const { user } = useAuth();
  const [daMostrare, setDaMostrare] = useState(false);
  const [letto, setLetto]           = useState(false);
  const [salvando, setSalvando]     = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get(`/privacy/stato?versione=${VERSIONE}`)
      .then(r => setDaMostrare(!r.data?.presaVisione))
      .catch(() => setDaMostrare(false));
  }, [user]);

  const conferma = async () => {
    setSalvando(true);
    try {
      await api.post('/privacy/presa-visione', { versione: VERSIONE });
      setDaMostrare(false);
    } catch (e) {
      alert('Non è stato possibile registrare la presa visione: ' + e.message);
    } finally {
      setSalvando(false);
    }
  };

  const alloScorrimento = (e) => {
    const el = e.target;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) setLetto(true);
  };

  if (!user || !daMostrare) return null;

  return (
    <div style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,.65)', zIndex:4000,
      display:'flex', alignItems:'center', justifyContent:'center', padding:20,
    }}>
      <div style={{
        background:'#fff', borderRadius:14, width:'100%', maxWidth:680,
        maxHeight:'90vh', display:'flex', flexDirection:'column',
      }}>
        <div style={{ padding:'20px 26px 12px', borderBottom:'1px solid #e5e7eb' }}>
          <h3 style={{ margin:0, fontSize:17 }}>
            Informativa sul trattamento dei dati personali
          </h3>
          <p style={{ margin:'6px 0 0', fontSize:12, color:'#6b7280' }}>
            Prima di proseguire ti chiediamo di prendere visione di come vengono trattati i tuoi dati.
          </p>
        </div>

        <div onScroll={alloScorrimento}
          style={{ padding:'8px 26px 20px', overflowY:'auto', flex:1 }}>
          <TestoInformativa />
        </div>

        <div style={{ padding:'14px 26px 20px', borderTop:'1px solid #e5e7eb' }}>
          {!letto && (
            <p style={{ margin:'0 0 10px', fontSize:12, color:'#9ca3af', textAlign:'center' }}>
              Scorri il testo fino in fondo per proseguire
            </p>
          )}
          <button className="btn btn-primary" style={{ width:'100%' }}
            onClick={conferma} disabled={!letto || salvando}>
            {salvando ? 'Registrazione…' : 'Ho preso visione'}
          </button>
          <p style={{ margin:'10px 0 0', fontSize:11, color:'#9ca3af', textAlign:'center' }}>
            Verranno registrati data, ora e versione del documento.
          </p>
        </div>
      </div>
    </div>
  );
}
